export function pluralize(prop, text) {
  return `${prop} ${prop < 2 ? text : text + 's'}`
}

// Bold the text before the separator. Use alternative separator if nothing returned.
export function fBoldText(text, separator, separatorAlt) {
  let arr = text.split(separator);
  let separatorUnit = separator;
  if (arr.length < 2) {
    arr = text.split(separatorAlt);
    separatorUnit = separatorAlt;
  }
  if (arr.length > 1) {
    const result = arr.splice(0,1);
    result.push(arr.join(separatorUnit));
    return `<b>${result[0]}${separatorUnit}</b> ${result[1]}`;
  }
  return text;
}

export const fRemoveValueFromArray = (arr, key) => {
  const index = arr.indexOf(key);
  if (index > -1) {
    arr.splice(index,1);
  }
  return arr;
}

export const groupBy = (array, key) => {
  // Return the end result
  return array.reduce((result, currentValue) => {
    // If an array already present for key, push it to the array. Else create an array and push the object
    (result[currentValue[key]] = result[currentValue[key]] || []).push(
      currentValue
    );
    // Return the current iteration `result` value, this will be taken as next iteration `result` value and accumulate
    return result;
  }, {}); // empty object is the initial value for result object
};

// Parse HTML String
export const fParseHTMLString = (text) => {
  if (!text) { return; }
  // if link exists, add external and targets
  let arr = text.split('<a');
  return arr.join('<a class="external" target="_blank" onclick="return false;" style="cursor: text !important; pointer-events: none; text-decoration: none; color: #333;"');
}

// convert feet and inches to inches
export const fConvertToInches = (iFt, iIn) => { 
  const iFtVal = Number(iFt) || 0;
  const iInVal = Number(iIn) || 0;
  return iFtVal * 12 + iInVal;
}

// convert inches to feet and inches
export const fConvertToFtIn = (iIn) => {
  if (!iIn) {return;}
  const iFtVal = Math.floor(Number(iIn) / 12);
  const iInVal = Number(iIn) % 12;
  return [iFtVal, iInVal];
}

// convert inches to cm
export const fConvertInchesToCM = (iIn) => {
  if (!iIn) {return;}
  return Math.floor(iIn * 2.54);
}

// convert cm to inches
export const fConvertCMToInches = (iCM) => {
  if(!iCM) { return; }
  return Math.floor(iCM / 2.54);
}
// convert kg to lb
export const fConvertKGToLB = (iKG) => {
  if (!iKG) {return;}
  return  Math.floor(iKG * 2.20);
}

// convert lb to kg
export const fConvertLBToKG = (iLB) => {
  if (!iLB) {return;}
  return Math.floor(iLB/2.20);
}

// Reset filter
export const fResetFilter = (oStore) => {
  if (!oStore) { return; }
  const arrsKey = Object.keys(oStore);
  arrsKey.forEach(key => {
    if (key !== 'grade') {
      oStore[key].values = [];
      if(oStore[key] && oStore[key].options) {
        // reset button
        oStore[key].options.forEach(option => {
          option.isActive = false;
        });
      }
    } else {
      oStore[key].values = ['A', 'B', 'C', 'D', 'I'];
      oStore[key].options.forEach(option => {
        option.isActive = option.display === 'all' ? true : false;
      });
    }
  });
}

// Calculate BMI from weight (lbs) and height (in)
export const fCalculateBMI = (iWeight, iHeight) =>{
  /*
  UW: Underweight
  N: Normal
  O: Overweight
  OB: Obese
  
  BMI <= 18.5 : Underweight
  18 < BMI <= 25 : Normal
  25 < BMI < 30 : Overweight
  BMI >= 30 : Obesity

  Formula: 703 x (weight (lbs) / [height (in)]2)
  */
  let iBMIVal = 703 * parseFloat(iWeight / Math.pow(iHeight, 2));
  iBMIVal = iBMIVal.toFixed(1);
  let def = false;
  let categories = [];
  if (iBMIVal <= 18.5) {
    def= {"abbr":"UW", "display": "Underweight"};
    categories = ["UW"];
  } else if (iBMIVal <= 25) {
    def= {"abbr":"N", "display": "Normal"};
    categories = ["N"];
  } else if (iBMIVal < 30) {
    def= {"abbr":"O", "display": "Overweight"};
    categories = ["N","O"];
  } else {
    def= {"abbr":"OB", "display": "Obese"};
    categories = ["N","O","OB"];
  }
  return {"value": iBMIVal, "label": def, "categories": categories};
}

export const fPrintDivById = (divId) => {
  document.getElementById(divId).classList.add("section-to-print-body");
  window.print();
  document.getElementById(divId).classList.remove("section-to-print-body");
}